import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import { useNavigate } from 'react-router-dom'
import ToggleSwitcher from '../../../components/v2/buttons/ToggleSwitcher'
import GreenTick from '../../../assets/v2/JSX/GreenTick'
import RedCross from '../../../assets/v2/JSX/RedCross'
import { Container } from '../../../assets/styles/GlobalStyle'
import {
  CriticalIllnessState,
  setChooseMethod,
  setCurrency,
  setHeaderPassedCount,
  setLimit,
  setOffer,
  setPaymentScheduleInfo,
} from '../../../store/criticalIllnessSlice'
import { useAppDispatch, useAppSelector } from '../../../store'
import Dropdown from '../../../components/v2/Dropdown'
import CriticalProgressbar from '../../../components/v2/progrees-bars/CriticalProgressbar'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import { currencySymbol, georgianFormatter } from '../../../domain/types'
import Loader from '../../../components/Loader'
import api from '../../../api'
import PriceAccordion from '../../../components/v2/accordions/PriceAccordion'
import { AppState } from '../../../store/appSlice'

//
//
const CriticalOffers = () => {
  //
  //
  const dispatch = useAppDispatch()
  //
  const { filter, screenHeader } = useAppSelector((data: { critical: CriticalIllnessState }) => data.critical)
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const { t } = useTranslation()
  //
  const navigate = useNavigate()
  //
  const { data: pageInfo, isLoading: isPageInfoLoading } = api.useGetPetPageInfoQuery('critical-which-offer')
  //
  const pageTitle = pageInfo?.translations?.[lang]?.title
  const stepName = pageInfo?.translations?.[lang]?.stepName
  //
  const fakeData = {
    currencies: [
      {
        id: 1,
        type: 'gel',
        title: 'GEL',
        translations: {
          ge: {
            title: 'ლარი',
          },
          en: {
            title: 'GEL',
          },
        },
      },
      {
        id: 2,
        type: 'usd',
        title: 'USD',
        translations: {
          ge: {
            title: 'დოლარი',
          },
          en: {
            title: 'USD',
          },
        },
      },
      {
        id: 3,
        type: 'eur',
        title: 'EUR',
        translations: {
          ge: {
            title: 'ევრო',
          },
          en: {
            title: 'EUR',
          },
        },
      },
    ],
    limits: [
      {
        id: 1,
        value: 20000,
      },
      {
        id: 2,
        value: 25000,
      },
    ],
  }
  //
  const currencies = fakeData.currencies
  //
  const limits = fakeData.limits
  //
  //declaring choose method if someone visits via url
  useEffect(() => {
    dispatch(setChooseMethod('my-choice'))
  }, [dispatch])
  //
  const MainLoading = isPageInfoLoading
  //
  return MainLoading ? (
    <Loader />
  ) : (
    <>
      <Wrapper>
        <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />
        <Content>
          <Title text={pageTitle} />

          <CriticalProgressbar stepName={stepName} />

          <Container>
            <Schedule>
              <span
                style={{
                  color: filter?.paymentSchedule?.id === 2 ? Colors.nevadaGrey : Colors.primaryBlack,
                }}
              >
                {t('monthly')}
              </span>
              <ToggleSwitcherStyle
                activeRedBackground={true}
                defaultValue={filter.paymentSchedule?.type === 'MONTHLY' ? false : true}
                onChange={(value) => {
                  if (value === true) {
                    dispatch(
                      setPaymentScheduleInfo({
                        id: 2,
                        type: 'ONE-TIME',
                      }),
                    )
                  } else {
                    dispatch(
                      setPaymentScheduleInfo({
                        id: 1,
                        type: 'MONTHLY',
                      }),
                    )
                  }
                }}
              />
              <span
                style={{
                  color: filter?.paymentSchedule?.id === 1 ? Colors.nevadaGrey : Colors.primaryBlack,
                }}
              >
                {t('annual')}
              </span>
            </Schedule>

            <Block>
              {filter.companyOffers?.map((item, index) => {
                const price =
                  filter?.companyOffers && filter?.companyOffers.length >= 1
                    ? filter?.paymentSchedule?.type === 'ONE-TIME'
                      ? georgianFormatter.format(item.calculatedPrices?.annual)
                      : georgianFormatter.format(item.calculatedPrices?.monthly)
                    : '0'
                return (
                  <PriceAccordion
                    key={index}
                    isBestPrice={item?.isBest ? item.isBest : false}
                    price={`${price}${currencySymbol('GEL')}`}
                    docUrl={''}
                    headTitle={item?.brandName?.[lang]?.title}
                    imgUrl={item?.companyLogo}
                    isSelected={item.companyId === filter.offer?.companyId}
                    onClick={() => {
                      dispatch(setOffer(item))
                    }}
                  >
                    {/* CONTENT */}
                    <HR />
                    <AddonsTitle>{t('youCanChange')}</AddonsTitle>

                    <DropdownWrapper>
                      <Dropdown
                        value={filter.currency || ''}
                        title={`${t('currency')}`}
                        options={currencies.map((x) => ({
                          value: x.type,
                          label: x.title?.toUpperCase(),
                        }))}
                        onChange={(obj) => dispatch(setCurrency(obj.value))}
                      />

                      <Dropdown
                        value={filter.limit || ''}
                        title={`${t('limit')}`}
                        options={limits.map((x) => ({
                          value: x.value,
                          label:
                            x?.value?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') +
                            ` ${currencySymbol(filter.currency || 'gel')}`,
                        }))}
                        onChange={(obj) => dispatch(setLimit(Number(obj.value)))}
                      />
                    </DropdownWrapper>

                    <br />

                    <ServicesBlock>
                      <ServicesTitle>{t('service')}</ServicesTitle>

                      {item.services?.map((service, index) => (
                        <TextDiv key={index}>
                          <LeftText>{service.title}</LeftText>
                          <RightText>{service.covered === true ? <GreenTick /> : <RedCross />}</RightText>
                        </TextDiv>
                      ))}
                    </ServicesBlock>
                    {/* CONTENT */}
                  </PriceAccordion>
                )
              })}
            </Block>
          </Container>

          <Buttons>
            <NavigationButton
              text={`${t('back')}`}
              buttonType="prev"
              onClick={() => [setHeaderPassedCount(screenHeader.passedCount - 1), navigate('/critical-choose-method')]}
            />
            <NavigationButton
              text={`${t('next')}`}
              buttonType="next"
              disabled={false}
              onClick={() => [navigate('/critical-offer'), setHeaderPassedCount(6)]}
            />
          </Buttons>
        </Content>

        <BackgroundIcon shortKite={true} />
      </Wrapper>
    </>
  )
}
//
//

const ServicesBlock = styled.div`
  display: flex;
  flex-direction: column;
`

const RightText = styled.div`
  text-align: right;
`
const LeftText = styled.div`
  width: 90%;
`
const TextDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${Colors.nevadaGrey};
  font-size: 14px;
  &:not(:last-child) {
    margin-bottom: 14px;
  }
`

const Schedule = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-block: 32px;
  gap: 10px;

  span {
    font-size: 18px;
    line-height: 17px;
    color: ${Colors.primaryBlack};
  }
  svg {
    color: ${Colors.secondaryGrey};
  }

  ${Responsive.mobile} {
    margin-block: 24px;
  }
`

const Block = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  column-gap: 32px;
  row-gap: 20px;
  margin-top: 32px;

  ${Responsive.tablet} {
    flex-direction: column;
  }

  ${Responsive.mobile} {
    flex-direction: column;
  }
`

const Content = styled.div`
  margin-top: 58px;
  width: 100%;
  z-index: 1;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 100px;
  min-height: 100vh;
  ${Responsive.tablet} {
    padding-bottom: 65px;
  }
  ${Responsive.mobile} {
    padding-bottom: 56px;
  }
`

const DropdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`
const AddonsTitle = styled.h6`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  margin-bottom: 20px;
`

const HR = styled.hr`
  background-color: ${Colors.secondaryGrey};
  margin-block: 24px;
`

const ServicesTitle = styled.h6`
  font-size: 14px;
  color: ${Colors.primaryBlack};
  margin-bottom: 20px;
`

const ToggleSwitcherStyle = styled(ToggleSwitcher)`
  label {
    margin-left: 20px;
  }
`

const Buttons = styled.div`
  display: flex;
  gap: 20px;
  width: min-content;
  margin-top: 48px;
  margin-inline: auto;
  button {
    width: 175px;
  }

  ${Responsive.mobile} {
    margin-top: 40px;
    gap: 16px;
    button {
      width: 140px;
    }
  }
`
//
export default CriticalOffers
